import React from 'react';
import './Landing.css';

const Landing = () => {
  return (
    <main className='main-content'>
      <h1>HEY, MY NAME IS</h1>
      <h1>JERNEJ JAKOP</h1>
      <h1>
        A <span>FULLSTACK</span> DEV
      </h1>
      <div className='scroll-indicator'>SCROLL</div>
    </main>
  );
};

export default Landing;
